import * as React from 'react'
import { ActivityIndicator, Text, TouchableOpacity, View } from 'react-native'
import styled from '@theme/styled-components'

import Icon from '@components/icon/Icons'

import theme from '@theme/Theme'

const ICON_SIZE = 24

interface Props {
  color?: ButtonColor
  label: string
  leftIcon?: IconName
  onClick: () => void
  rightIcon?: IconName
  status: ButtonStatus
  textOnly?: boolean
  textColor?: string
}

const Button = ({
  color = 'default',
  label,
  leftIcon,
  onClick,
  rightIcon,
  status,
  textOnly = false,
  textColor,
}: Props) => {
  return (
    <View>
      <Container activeOpacity={0.9} color={color} disabled={status !== 'active'} onPress={onClick} textOnly={textOnly}>
        {!!leftIcon && (
          <LeftIcon>
            <Icon
              name={leftIcon}
              size={ICON_SIZE}
              color={
                color === 'light'
                  ? theme.colors.primary
                  : color === 'cancel'
                  ? theme.colors.primaryText
                  : theme.colors.background
              }
            />
          </LeftIcon>
        )}
        <Label numberOfLines={2} adjustsFontSizeToFit color={color} textOnly={textOnly} textColor={textColor}>
          {label}
        </Label>
        {!!rightIcon && (
          <RightIcon>
            <Icon
              name={rightIcon}
              size={ICON_SIZE}
              color={
                color === 'light'
                  ? theme.colors.primary
                  : color === 'cancel'
                  ? theme.colors.primaryText
                  : theme.colors.background
              }
            />
          </RightIcon>
        )}
      </Container>
      {status !== 'active' && (
        <DisabledOverlay>
          {status === 'loading' && <ActivityIndicator color={theme.colors.primary} size={25} />}
        </DisabledOverlay>
      )}
    </View>
  )
}

export default Button

const Container = styled(TouchableOpacity)<{ color: ButtonColor; textOnly: boolean }>`
  overflow: hidden;
  height: 48px;
  flex-direction: row;
  justify-content: center;
  align-items: center;
  ${(props) => !props.textOnly && `padding: 0px 16px;`}
  border-radius: 4px;
  background-color: ${(props) =>
    props.textOnly
      ? 'transparent'
      : props.color === 'light'
      ? props.theme.colors.primaryLight
      : props.color === 'cancel'
      ? props.theme.colors.priority
      : props.theme.colors.primary};
  z-index: -1;
`
const Label = styled(Text)<{ color: ButtonColor; textOnly: boolean; textColor?: string }>`
  ${(props) => props.theme.fonts.Callout};
  color: ${(props) =>
    props.textColor ||
    (props.color === 'cancel'
      ? props.theme.colors.primaryText
      : props.color === 'light' || props.textOnly
      ? props.theme.colors.primary
      : props.theme.colors.background)};
  text-align: center;
`
const LeftIcon = styled(View)`
  margin-right: 12px;
`
const RightIcon = styled(View)`
  margin-left: 12px;
`
const DisabledOverlay = styled(View)`
  position: absolute;
  align-self: center;
  z-index: 1;
  height: 100%;
  width: 100%;
  background-color: rgb(255 255 255 / 70%);
  justify-content: center;
  align-items: center;
  border-radius: 4px;
`
